// Datos de DEMOSTRACIÓN con la forma exacta del contrato (§6 del diseño).
// Solo se usan con VITE_MARKETING_OS_MOCK=1 o si el usuario los pide mientras
// el backend aún no responde; la pantalla los rotula «Demostración».
// Borrar este archivo cuando el backend de Marketing esté desplegado.

import type { Medicion, Presupuesto, Resumen } from './api';

function dias(desde: string, hasta: string): string[] {
  const out: string[] = [];
  const d = new Date(`${desde}T12:00:00Z`);
  const fin = new Date(`${hasta}T12:00:00Z`);
  while (d <= fin && out.length < 92) {
    out.push(d.toISOString().slice(0, 10));
    d.setUTCDate(d.getUTCDate() + 1);
  }
  return out;
}

export function mockResumen(desde: string, hasta: string): Resumen {
  const serie = dias(desde, hasta).map((fecha, i) => ({
    fecha,
    gasto_cents: 15000 - ((i * 1300) % 4000),
    leads: (i * 7) % 5,
    compras: i % 6 === 5 ? 1 : 0,
  }));
  const gasto = serie.reduce((a, p) => a + p.gasto_cents, 0);
  const leads = serie.reduce((a, p) => a + p.leads, 0);
  const compras = serie.reduce((a, p) => a + p.compras, 0);
  const ingreso = compras * 490000;
  return {
    org_id: 'demo',
    desde,
    hasta,
    moneda: 'MXN',
    presupuesto: {
      mes: desde.slice(0, 7),
      tope_cents: 800000,
      gastado_cents: gasto,
      ritmo: gasto > 600000 ? 'alto' : 'ok',
      por_canal: [
        { canal: 'meta', tope_cents: 650000, gastado_cents: Math.round(gasto * 0.85) },
        { canal: 'google', tope_cents: 150000, gastado_cents: Math.round(gasto * 0.15) },
      ],
    },
    totales: {
      gasto_cents: gasto,
      impresiones: 48210,
      clics: 731,
      leads,
      compras,
      ingreso_cents: ingreso,
      cpl_cents: leads ? Math.round(gasto / leads) : null,
      cpa_cents: compras ? Math.round(gasto / compras) : null,
      roas: gasto ? Math.round((ingreso / gasto) * 100) / 100 : null,
    },
    por_canal: [
      { canal: 'meta', gasto_cents: Math.round(gasto * 0.85), leads: Math.round(leads * 0.6), compras, ingreso_cents: ingreso, cpl_cents: 5400, cpa_cents: null, },
      { canal: 'google', gasto_cents: Math.round(gasto * 0.15), leads: Math.round(leads * 0.15), compras: 0, ingreso_cents: 0, cpl_cents: 7200, cpa_cents: null },
      { canal: 'whatsapp', gasto_cents: 0, leads: Math.round(leads * 0.15), compras: 0, ingreso_cents: 0, cpl_cents: null, cpa_cents: null },
      { canal: 'organico', gasto_cents: 0, leads: Math.round(leads * 0.1), compras: 0, ingreso_cents: 0, cpl_cents: null, cpa_cents: null },
    ],
    por_campana: [
      { registry_id: 1, canal: 'meta', nombre: 'Lanzamiento · Leads · Prospección', estado: 'active', cuenta: 'Cuenta demo (act_000)', gasto_cents: Math.round(gasto * 0.85), impresiones: 41200, clics: 640, leads: Math.round(leads * 0.6), compras, cpl_cents: 5400 },
      { registry_id: 2, canal: 'google', nombre: 'Búsqueda local', estado: 'paused', cuenta: 'Google Ads demo', gasto_cents: Math.round(gasto * 0.15), impresiones: 7010, clics: 91, leads: Math.round(leads * 0.15), compras: 0, cpl_cents: 7200 },
    ],
    serie_diaria: serie,
    embudo: { visitas: 1840, leads, checkouts: Math.max(compras * 3, 4), compras },
    alertas: [
      { tipo: 'cpl', severidad: 'warn', mensaje: 'El anuncio «Competencia» lleva 3 días con costo por lead 2× arriba del promedio.' },
      { tipo: 'tracking', severidad: 'info', mensaje: 'Google Ads todavía no tiene conversiones configuradas.' },
    ],
    actualizado: new Date().toISOString(),
  };
}

export function mockPresupuesto(mes: string): Presupuesto {
  return {
    mes,
    moneda: 'MXN',
    tope_cents: 800000,
    por_canal: [
      { canal: 'meta', tope_cents: 650000 },
      { canal: 'google', tope_cents: 150000 },
    ],
    alertas_pct: [80, 100],
  };
}

export function mockMedicion(): Medicion {
  return {
    meta: {
      pixel_id: '0000000000000000',
      capi: true,
      ultimo_evento: new Date(Date.now() - 4 * 60_000).toISOString(),
      eventos_24h: { PageView: 214, ViewContent: 61, Lead: 4, InitiateCheckout: 2 },
    },
    google: { ga4_id: null, ads_id: null, conectado: false },
    cuentas: [
      { canal: 'meta', id: 'act_000', nombre: 'Cuenta demo', paga: 'Tarjeta terminación 0000', estado: 'ok' },
      { canal: 'google', id: '000-000-0000', nombre: 'Google Ads demo', paga: '—', estado: 'error' },
    ],
    problemas: ['Google Ads no está conectado: no se mide el gasto ni las conversiones de búsqueda.'],
  };
}
